import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import PropTypes from 'prop-types';
import lodash from 'lodash';

/**
 * 
 * Componente de utilería para el manejo de las rutas dentro de la aplicación
 * Se valida el token del usuario en sesión para así ver si es 
 * posible o no entrar a ciertas escenas.
 */

const PrivateRoute = ({ component: Component, render,...rest }) => {
  let expiration = localStorage.getItem("expires_in");
  let strToken = localStorage.getItem("token");
  let isAbletoEnter = false;
  if(strToken && parseInt(expiration,10) > Date.now()/1000){
    let roles = localStorage.getItem('role').split(',');
    isAbletoEnter = lodash.intersection(rest.roles, roles).length > 0;
    // En caso de que una ruta requiera de uno o varios roles obligatiorios
    // Hay que borrar esto una vez que se complete la prueba piloto
    if(isAbletoEnter && rest.rolObligatorio != undefined && rest.rolObligatorio != null && typeof(rest.rolObligatorio) === "object" && rest.rolObligatorio.length > 0){
      isAbletoEnter = lodash.intersection(rest.rolObligatorio, roles).length > 0
    }
  }else{
    localStorage.clear();
    window.location.reload();
  }

  return (
    <Route
      {...rest}
      render={props =>
        isAbletoEnter ? (
          render 
            ? render(props)
            : <Component {...props} />
        ) :
        (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  )
}

PrivateRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.func.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string)
}

PrivateRoute.defaultProps = {
  roles: []
}

export default PrivateRoute